import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const DeleteLogReport = () => {
  const [loading, setLoading] = useState(false);
  const [deleteLogList, setDeleteLogList] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const [filters, setFilters] = useState({
    search: "",
  });
  const [tempSearch, setTempSearch] = useState("");

  const navigate = useNavigate();

  const getAuthHeader = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });



const formatDate = (dateTimeString) => {
  if (!dateTimeString) return "-";

  const date = new Date(dateTimeString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

const formatTime = (dateTimeString) => {
  if (!dateTimeString) return "-";

  const date = new Date(dateTimeString);
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12;
  const formattedHours = String(hours).padStart(2, '0');

  return `${formattedHours}:${minutes}:${seconds} ${ampm}`;
};

  const fetchDeleteLogReport = async (pageNo = 1, searchTerm = filters.search) => {
    try {
      setLoading(true);
      setPage(pageNo);

      const payload = {
        page: pageNo.toString(),
        per_page: perPage.toString(),
        search: searchTerm,
      };

      const res = await axios.post(
        `${BASE_URL}/dataDeletedLogReports`,
        payload,
        getAuthHeader()
      );

      if (res.data.status) {
        setDeleteLogList(res.data.data || []);
        setTotalRecords(res.data.total_records || 0);
        setTotalPages(Math.ceil((res.data.total_records || 0) / perPage));
      } else {
        setDeleteLogList([]);
        setTotalRecords(0);
        setTotalPages(1);
      }
    } catch (err) {
      if (err.response?.status === 401) {
        handle401();
      } else {
        Swal.fire("Alert", "Failed to fetch delete log report", "error");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    setPage(1);
    setFilters({ ...filters, search: tempSearch });
    fetchDeleteLogReport(1, tempSearch);
  };

  const handleReset = () => {
    setTempSearch("");
    setFilters({ search: "" });
    setPage(1);
    setPerPage(10);
    fetchDeleteLogReport(1, "");
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;

    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + maxPagesToShow - 1);

    if (end - start < maxPagesToShow - 1) {
      start = Math.max(1, end - maxPagesToShow + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  useEffect(() => {
    fetchDeleteLogReport(1, "");
  }, [perPage]);

  const theadStyle = {
    padding: "5px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    backgroundColor: "#edf7fe",
    borderBottom: "1px solid black",
    borderTop: "1px solid black",
    textAlign: "center",
  };

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* Filter Card */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div
          className="px-4 py-3 text-white rounded-top"
          style={{
            background: "linear-gradient(90deg, #0D47A1, #1565C1)",
          }}
        >
          <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
            <i className="fa-solid fa-filter"></i> Action Data Log Report
          </h5>
        </div>
        <Card.Body className="px-4 py-4">
          <Row className="align-items-end">
            {/* <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">Search</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Search by action, user..."
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                  value={tempSearch}
                  onChange={(e) => setTempSearch(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      handleSearch();
                    }
                  }}
                />
              </Form.Group>
            </Col> */}

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">Records Per Page</Form.Label>
                <Form.Select
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                  value={perPage}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setPerPage(value);
                    setPage(1);
                  }}
                >
                  <option value={10}>10 Per Page</option>
                  <option value={25}>25 Per Page</option>
                  <option value={50}>50 Per Page</option>
                  <option value={100}>100 Per Page</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3} className="d-flex gap-3 mb-3">
              {/* SEARCH BUTTON */}
              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#1565C1",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#0D47A1")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "#1565C1")}
                onClick={handleSearch}
              >
                <i className="fa-solid fa-magnifying-glass me-2"></i> Search
              </Button>

              {/* RESET BUTTON */}
              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#E53935",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#D32F2F")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "#E53935")}
                onClick={handleReset}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Table Card */}
      <Card className="border-0 shadow">
        <Table bordered hover responsive striped>
  <thead>
    <tr>
      <th style={theadStyle}>SL No.</th>
      <th style={theadStyle}>Action</th>
      <th style={theadStyle}>Action By</th>
      <th style={theadStyle}>Action Date & Time</th>
    </tr>
  </thead>
  <tbody>
    {loading ? (
      <tr>
        <td colSpan={4} className="text-center py-4">
          <div className="loader-wrapper">
            <div className="blue-spinner"></div>
            <div className="loading-line">
              <div className="loading-progress"></div>
            </div>
            <p className="loading-text">Please Wait... While Gathering Reports</p>
          </div>
        </td>
      </tr>
    ) : deleteLogList.length ? (
      deleteLogList.map((row, i) => (
        <tr key={row.id || i}>
          <td className="text-center" style={{ verticalAlign: "middle" }}>
            {(page - 1) * perPage + i + 1}
          </td>
          <td style={{ verticalAlign: "middle" }}>{row.remarks}</td>
          <td className="text-center" style={{ verticalAlign: "middle" }}>
            {row.deleted_by}
          </td>
          <td className="text-center" style={{ verticalAlign: "middle" }}>
            {formatDate(row.created_at)} <br/> {formatTime(row.created_at)}
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={4} className="text-center py-4 text-muted">
          <i className="fa-solid fa-inbox me-2"></i> No Data Found
        </td>
      </tr>
    )}
  </tbody>
</Table>

        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-4 mb-3">
            <nav>
              <ul className="pagination shadow-sm">
                {/* First */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => fetchDeleteLogReport(1, filters.search)}
                  >
                    «
                  </button>
                </li>

                {/* Prev */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => fetchDeleteLogReport(page - 1, filters.search)}
                  >
                    ‹
                  </button>
                </li>

                {/* Page Numbers */}
                {getPageNumbers().map((p) => (
                  <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => fetchDeleteLogReport(p, filters.search)}
                    >
                      {p}
                    </button>
                  </li>
                ))}

                {/* Next */}
                <li
                  className={`page-item ${page === totalPages ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => fetchDeleteLogReport(page + 1, filters.search)}
                  >
                    ›
                  </button>
                </li>

                {/* Last */}
                <li
                  className={`page-item ${page === totalPages ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => fetchDeleteLogReport(totalPages, filters.search)}
                  >
                    »
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}

        {/* Showing Records Info */}
        {/* {deleteLogList.length > 0 && (
          <div className="text-center text-muted mb-3">
            <small>
              Showing {((page - 1) * perPage) + 1} to {Math.min(page * perPage, totalRecords)} of {totalRecords} records
            </small>
          </div>
        )} */}
      </Card>
    </div>
  );
};

export default DeleteLogReport;
